"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PromoCodesPanel", {
  enumerable: true,
  get: function get() {
    return _PromoCodesPanel["default"];
  }
});
var _PromoCodesPanel = _interopRequireDefault(require("./PromoCodesPanel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }